<template>
  <div></div>
</template>

<script>
/* eslint-disable */
import api from '@/pages/uc-web/api/api';
export default {
  data() {
    return {
      token:this.$route.query.token || '',
      id:this.$route.query.id || 2
    }
  },
  mounted() {
    console.log(this.token)
    // 区分是预习中心还是测评中心
    localStorage.setItem('changeId',this.id)
    localStorage.setItem('ddToken',this.token)
    this.tokenLogin()
  },
  methods: {
    // 提交登录
    async tokenLogin() {
      const res = await api.loginByDd(this.token);
      if (res) {
        if (res.code === 200) {
          // this.$toast('登录成功');
            this.$router.push({
              path: '/uc-web/center',
            });
          localStorage.setItem('source_type', res.data.source_type);
          localStorage.setItem('real_name', res.data.real_name);
          localStorage.setItem('account_id', res.data.account_id);
          localStorage.setItem('school_id', res.data.school_id);
          // localStorage.setItem('user_token', res.data.user_token);
          localStorage.setItem('school_nature_id', res.data.school_nature_id);
          
          
        } else {
          this.$toast(res.msg);
        }
      } else {
        console.log('error submit!!');
      }
    },
  },
};
</script>

<style>

</style>
